import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { Form } from '../components/Form';

import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export const TacticP1Leanpay = ({hibisId}) => {

  return (
    <>
      <Header />
      <Hero image="oskar-leanpay.jpg" xPos="70%" yPos="46%" />
      <div className="addiko-app">
        <Container>
            <Row>
                <Col md={6} className="p-3">
                    <h1>Enoten obrok, več gotovine – za Leanpay stranke.</h1>
                    <p className="text-left">
                      Ker je Addiko banka partner Leanpay, imate kot njihova stranka možnost, da s preprostim gotovinskim kreditom:
                    </p>                   
                    <ul className="mt-3">
                      <li>
                        poravnate svoje obstoječe obveznosti,
                      </li>
                      <li>
                        vse združite v enoten mesečni obrok,
                      </li>
                      <li>
                        hkrati pridobite dodatna sredstva za druge potrebe.
                      </li>
                    </ul> 
                    <p className="text-left">
                      <b>Vas zanima več? Sporočite nam svoje kontaktne podatke in v kratkem vas pokličemo!</b>
                    </p>
                    <p className="text-left text-small">
                        Kjerkoli in kadarkoli, vedno z vami!<br />
                        Addiko banka
                    </p>
                </Col>
                <Col md={1} className="p-3 d-none d-md-block">
                    &nbsp;
                </Col>
                <Col md={5} className="p-3">
                  <Form guid="03930c38-5857-482c-924f-1c4dca611318" hibisId={hibisId} />
                </Col>
            </Row>
        </Container>
      </div>      
      <Footer />
    </>
  );
}